(function () {
  // --- helpers --------------------------------------------------------------
  function getDrawerHost() {
    return (
      document.querySelector('[data-cart-drawer][data-section-id]') ||
      document.querySelector('.cart-drawer[data-section-id]') ||
      document.querySelector('.drawer[data-section-id]')
    );
  }

  // (opcional – você não está usando mais, mas deixei aqui caso precise)
  function extractDrawerHTML(json, sid, handle) {
    if (sid && json[sid]) return json[sid];
    if (handle && json[handle]) return json[handle];
    if (sid) {
      const k = Object.keys(json).find((key) => key.includes(sid));
      if (k) return json[k];
    }
    if (json['cart-drawer']) return json['cart-drawer'];
    return null;
  }

  // --- re-render do drawer e da bolha --------------------------------------
  async function refreshDrawerAndBubble() {
    const host =
      document.querySelector('[data-cart-drawer][data-section-id]') ||
      document.querySelector('.cart-drawer[data-section-id]') ||
      document.querySelector('.drawer[data-section-id]');

    const sid  = host ? host.getAttribute('data-section-id') : null;
    const root = (window.Shopify?.routes?.root) || '/';
    const anti = `&_=${Date.now()}`;

    // 1) Drawer por ID: retorna HTML
    const drawerUrl = sid ? `${root}?section_id=${encodeURIComponent(sid)}${anti}` : null;

    // 2) Bolha por handle: retorna JSON
    const bubbleUrl = `${root}?sections=cart-icon-bubble${anti}`;

    const [drawerRes, bubbleRes] = await Promise.all([
      drawerUrl ? fetch(drawerUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, cache: 'no-store' }) : Promise.resolve(null),
      fetch(bubbleUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' }, cache: 'no-store' }),
    ]);

    // Atualiza o drawer (preferindo trocar só o conteúdo do [data-cart-body])
    if (drawerRes) {
      if (!drawerRes.ok) throw new Error('section_id fetch failed');
      const drawerHTML = await drawerRes.text();

      const liveBody = document.querySelector('[data-cart-body]');
      if (liveBody) {
        const tmp = document.createElement('div');
        tmp.innerHTML = drawerHTML;
        const newBody = tmp.querySelector('[data-cart-body]');
        if (newBody) {
          liveBody.innerHTML = newBody.innerHTML;
        } else if (host) {
          host.outerHTML = drawerHTML; // fallback
        }
      } else if (host) {
        host.outerHTML = drawerHTML;
      }
    }

    // Atualiza bolha
    if (bubbleRes?.ok) {
      const bubbleJson = await bubbleRes.json();
      if (bubbleJson['cart-icon-bubble']) {
        const bubbleCur = document.querySelector('[data-cart-icon-bubble]');
        if (bubbleCur) bubbleCur.outerHTML = bubbleJson['cart-icon-bubble'];
      }
    }

    // Reabre e emite evento
    requestAnimationFrame(() => {
      const opener = document.querySelector('[data-open-cart-drawer]');
      const drawer = document.querySelector('cart-drawer');
      if (opener && typeof opener.click === 'function') opener.click();
      else if (drawer && typeof drawer.open === 'function') drawer.open();

      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'upsell' } }));
    });
  }

  // --- intercepta submits dos botões "+" do upsell (desktop e mobile) ------
  document.addEventListener('submit', async function (e) {
    const form = e.target;
    // IMPORTANTE: .cdu-panel está em BOTH: overlay (desktop) e inline (mobile)
    if (!form.closest('.cdu-panel')) return;

    e.preventDefault();

    const btn = form.querySelector('button[type="submit"]');
    const originalText = btn ? btn.textContent : null;
    if (btn) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
    }

    try {
      const fd   = new FormData(form);
      const root = (window.Shopify?.routes?.root) || '/';
      const addUrl = root + 'cart/add.js';

      // adiciona via AJAX (sem redirecionar pro cart nativo)
      const addRes = await fetch(addUrl, {
        method: 'POST',
        body: fd,
        headers: { 'Accept': 'application/json' }
      });
      if (!addRes.ok) throw new Error('add failed');
      await addRes.json();

      await refreshDrawerAndBubble();

      if (btn) btn.textContent = '✓';
      setTimeout(() => { if (btn) btn.textContent = originalText || '+'; }, 900);
    } catch (err) {
      console.error(err);
      alert('Não foi possível adicionar este item agora.');
    } finally {
      if (btn) {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      }
    }
  });
})();
